import { lazy } from 'react';

import { RouteObject } from '@/types/router';

import { LazyLoad } from '../utils/lazy-load';

export default [
  {
    path: '/rule',
    children: [
      {
        path: 'vip',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/rule/vip'))),
          },
        ],
      },
    ],
  },
] as RouteObject[];
